import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { PaginatedResponse } from '@/lib/api-types'
import { variablesForGroups } from '@/lib/message-variables'
import type { TemplateButton, TemplateHeader } from '@/types/templates'

// Mesmas variáveis oferecidas no editor de templates (grupos lead /
// responsável-organização / saudação) — o backend resolve todas via o renderer
// canônico. Mantém o mapeamento de variáveis consistente entre os dois lugares.
export const META_TEMPLATE_VARIABLE_OPTIONS = variablesForGroups([
  'lead',
  'responsavel_org',
  'saudacao',
]).map((variable) => ({ value: variable.key, label: variable.label }))

export interface SyncedMetaTemplate {
  id: string
  name: string
  language: string
  content: string
  variables: string[]
  header?: TemplateHeader | null
  footer?: string | null
  buttons?: TemplateButton[] | null
  source: 'META'
  status: 'APPROVED'
}

export function useSyncedMetaTemplates(orgId: string | null) {
  return useQuery<SyncedMetaTemplate[]>({
    queryKey: ['templates', orgId, 'meta-approved'],
    queryFn: async () => {
      const response = await api.get<PaginatedResponse<SyncedMetaTemplate>>(
        `/orgs/${orgId}/templates`,
        { params: { status: 'APPROVED', limit: 100 } }
      )
      return response.data.data.filter((template) => template.source === 'META')
    },
    enabled: Boolean(orgId),
  })
}
